module.exports = __webpack_public_path__ + "img/chromecast5.23dfaec3.png";